import App from './App.pug';

const app = new App({
	target: document.body
});

export default app;
